<template>
  <div class="g-content docs">
    <div class="docs-header">
      <h3>
        {{ $t('docs_welcome') }}（<span>{{ $t('docs_category_manage_title') }}</span
        >）
      </h3>
      <div class="docs-header-right">
        <a-button
          type="default"
          @click="
            () => {
              this.$router.push({ name: 'DocsList' });
            }
          "
        >
          {{ $t('docs_return_list') }}
        </a-button>
      </div>
    </div>

    <div class="g-content-main common-filter-main docs-category">
      <div class="docs-category-title">
        <!-- 添加 -->
        <a-button type="primary" @click="handleAdd" v-if="AUTH_DOCS_CATEGORY_ADD">
          {{ $t('docs_add_category_title') }}
        </a-button>
      </div>
      <div class="docs-category-content">
        <!-- 列表 -->
        <a-table
          :columns="columns"
          :data-source="categoryList"
          :rowKey="(text, index) => text.id"
          bordered
          :pagination="false"
          style="width:100%;"
        >
          <!-- 名称 -->
          <template slot="name" slot-scope="text">
            {{ text }}
          </template>

          <!-- 创建时间 -->
          <template slot="createTime" slot-scope="text">
            {{ text | formatDate }}
          </template>

          <!-- 更新人 -->
          <template slot="updateBy" slot-scope="text">
            <span v-if="text">{{ text }}</span>
            <span v-else>-</span>
          </template>

          <!-- 更新时间 -->
          <template slot="updateTime" slot-scope="text">
            <span v-if="text">{{ text | formatDate }}</span>
            <span v-else>-</span>
          </template>

          <!-- 操作 -->
          <template slot="Operation" slot-scope="text, record">
            <div class="docs-category-operation">
              <!-- 编辑 -->
              <a-button
                type="primary"
                @click="handleEdit(record)"
                class="g-btn-icon"
                v-if="AUTH_DOCS_CATEGORY_EDIT"
              >
                <Icon type="edit" />
              </a-button>

              <!-- 删除 -->
              <a-button
                type="red"
                @click="
                  deleteDocument({
                    params: { id: record.id },
                    name: record.name,
                  })
                "
                v-if="AUTH_DOCS_CATEGORY_DELETE"
                class="g-btn-icon"
              >
                <Icon type="delete" />
              </a-button>
            </div>
          </template>
        </a-table>
      </div>
    </div>

    <!-- 创建分类 -->
    <a-modal
      v-model="updateCategoryVisible"
      :title="isEdit ? $t('docs_edit_category_title') : $t('docs_add_category_title')"
      :footer="null"
      centered
      :maskClosable="false"
      destroyOnClose
    >
      <div class="docs-category-modal">
        <div class="docs-category-form">
          <a-form-model :model="form" :rules="rules" layout="vertical" ref="form">
            <!-- 名称 -->
            <a-form-model-item :label="$t('docs_form_name')" prop="name" style="margin-bottom: 0;">
              <a-input
                v-model="form.name"
                :placeholder="$t('docs_form_name_placeholder')"
                allowClear
                ref="formName"
              />
            </a-form-model-item>

            <!-- 文档简介 -->
            <a-form-model-item
              :label="$t('docs_form_description')"
              prop="intro"
              style="margin-bottom:0;"
            >
              <a-input
                type="textarea"
                v-model="form.intro"
                :placeholder="$t('docs_form_description_placeholder')"
                rows="5"
                allowClear
              />
            </a-form-model-item>

            <!-- 图标 -->
            <a-form-model-item :label="$t('docs_form_category_icon')" prop="icon">
              <UploadOSS
                :value="form.icon"
                :manuallyUpload="false"
                @change="
                  fileList => {
                    form.icon = fileList || [];
                  }
                "
                :maxCount="1"
                ref="uploadFile"
                uploadDirInOSS="document"
                uploadType="image"
              />
            </a-form-model-item>
          </a-form-model>
        </div>
        <div class="docs-category-btn">
          <a-button
            type="primary"
            @click="handleSubmit"
            class="g-btn-icon"
            size="large"
            :loading="submitting"
          >
            {{ $t('com_btn_save') }}
          </a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import * as DocsAPI from '@/api/docs';
import { deleteConfirm } from '@/libs/ant.design.fn';
import docsAuth from '@/views/docs/mixins/docsAuth';

export default {
  mixins: [docsAuth],
  components: {},
  name: 'Docs',
  data() {
    return {
      updateCategoryVisible: false,
      rules: {
        name: [
          {
            required: true,
            message: this.$t('docs_form_category_name'),
          },
        ],
      },

      categoryList: null,
      form: {
        name: undefined,
        intro: undefined,
        icon: undefined,
        id: undefined,
      },

      list: null,
      // 列表
      columns: [
        {
          title: this.$t('com_table_index'),
          customRender: (text, record, index) => `${index + 1}`,
          align: 'center',
          width: 60,
        },

        {
          title: this.$t('docs_table_category_name'),

          dataIndex: 'name',
          scopedSlots: { customRender: 'name' },
        },

        {
          title: this.$t('docs_table_category_description'),
          dataIndex: 'intro',
          scopedSlots: { customRender: 'intro' },
        },

        {
          title: this.$t('docs_detail_base_createBy'),

          dataIndex: 'createBy',
        },
        {
          title: this.$t('docs_detail_base_createTime'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
        },
        {
          title: this.$t('docs_detail_base_updateBy'),
          dataIndex: 'updateBy',
          scopedSlots: { customRender: 'updateBy' },
        },

        {
          title: this.$t('docs_detail_base_updateTime'),
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
        },

        {
          title: this.$t('site_table_operation'),
          align: 'center',
          scopedSlots: { customRender: 'Operation' },
          width: 80,
        },
      ],
      submitting: false,

      // 是否为编辑
      isEdit: false,
    };
  },
  watch: {
    updateCategoryVisible(val) {
      // 弹出时，清空数据先
      if (!val) {
        this.$refs.form.resetFields();
        this.form = {
          name: undefined,
          intro: undefined,
          icon: undefined,
          id: undefined,
        };
      } else {
        this.$nextTick(() => {
          this.$refs.formName.focus();
        });
      }
    },
  },
  created() {
    this.getAllDocuments();
  },
  methods: {
    // 调用分类列表
    getAllDocuments() {
      return DocsAPI.getAllCategories()
        .then(res => {
          if (res.code === 0 && res.data) {
            this.categoryList = res.data || [];
          }
        })
        .catch(() => {
          this.categoryList = null;
        })
        .finally(() => {
          this.$store.commit('setPageLoading', false);
        });
    },

    // 添加分类
    addCategorySubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitting = true;
          const params = {
            ...this.form,
          };
          if (params.icon && params.icon.length) {
            params.icon = this.form.icon[0];
          } else {
            delete params.icon;
          }

          DocsAPI.addCategory(params)
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_save_success'));
                this.updateCategoryVisible = false;
                this.getAllDocuments();
              }
            })
            .catch(() => {
              this.$message.error(this.$t('com_msg_save_fail'));
            })
            .finally(() => {
              this.submitting = false;
            });
        }
      });
    },

    editCategorySubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitting = true;
          const params = {
            ...this.form,
          };
          if (params.icon && params.icon.length) {
            params.icon = this.form.icon[0];
          } else {
            params.icon = '';
          }

          DocsAPI.editCategory(params)
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_save_success'));
                this.updateCategoryVisible = false;
                this.getAllDocuments();
              }
            })
            .catch(() => {
              this.$message.error(this.$t('com_msg_save_fail'));
            })
            .finally(() => {
              this.submitting = false;
            });
        }
      });
    },

    // 提交
    handleSubmit() {
      if (this.isEdit) {
        this.editCategorySubmit();
      } else {
        this.addCategorySubmit();
      }
    },

    // 添加
    handleAdd() {
      this.isEdit = false;
      this.updateCategoryVisible = true;
    },

    // 编辑
    handleEdit(item) {
      this.isEdit = true;
      this.form = {
        name: item.name,
        icon: [item.icon],
        intro: item.intro,
        id: item.id,
      };
      this.updateCategoryVisible = true;
    },

    // 删除文档
    deleteDocument({ params = {}, title = '', name = '' }) {
      if (params) {
        const h = this.$createElement;

        const options = {
          onOk: () => {
            this.$store.commit('setFreeze', this.$t('com_ongoing_delete'));
            DocsAPI.deleteCategory(params)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(this.$t('com_msg_delete_success'));

                  // 重新获取列表
                  this.getAllDocuments();
                }
              })
              .finally(() => {
                this.$store.commit('setFreeze', false);
              });
          },
        };

        // title
        options.title = title || this.$t('docs_form_category_delete_confirm');
        options.content = h('div', name);

        // content
        if (name) {
          options.content = h('div', name);
        }

        deleteConfirm.call(this, options);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.docs {
  background: @g-layout-background;
  .docs-header {
    padding: 16px 24px;
    border-radius: 12px;
    background: #fff;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    h3 {
      color: #18181a;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      margin: 0;
      span {
        color: #1838d9;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
      }
    }
    .docs-header-right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }

  .docs-category {
    background: #fff;
    padding: 16px 24px 8px 24px;
    border-radius: 12px;
    display: flex;
    flex: 1;
    flex-direction: column;
    .docs-category-title {
      color: #18181a;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 16px;
    }

    .docs-category-content {
      display: flex;
      padding: 24px 0;
      flex-direction: column;
      align-items: flex-start;
      gap: 24px;
      flex: 1 0 0;
      align-self: stretch;
    }
  }

  .docs-category-operation {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
  }
}

.docs-category-modal {
  .docs-category-btn {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>
